import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionTypes } from "../constants/action-types";
import { apiCall } from "../../api/api";


export const getAllCarriers = createAsyncThunk(
  ActionTypes.GET_ALL_CARRIERS,
  async ({ page = 1, limit = 5, search = '' }: { page?: number; limit?: number; search?: string }, { rejectWithValue }) => {
    try {
      const res = await apiCall(`admin/carriers?page=${page}&limit=${limit}&search=${search}`, "get");
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const registerAdmin = createAsyncThunk(
  ActionTypes.ADMIN_REGISTER,
  async (registerData: { email: string; password: string }, { rejectWithValue }) => {
    try {
      const res = await apiCall("admin/register", "post", registerData);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const loginAdmin = createAsyncThunk(
  ActionTypes.ADMIN_LOGIN,
  async (registerData: { email: string; password: string }, { rejectWithValue }) => {
    try {
      const res = await apiCall("admin/login", "post", registerData);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
